import Vue from 'vue';

import VueHeadful from 'vue-headful';
import VeeValidate from 'vee-validate';
import VueMq from 'vue-mq';
import UUID from 'vue-uuid';
import VTooltip from 'v-tooltip';
import ApiPlugin from '@/plugins/api';
import AxiosPlugin from '@/plugins/axios';
import SerializerPlugin from '@/plugins/serializer';

import BootstrapVue from 'bootstrap-vue'



import App from '@/App.vue';
import router from '@/router';
import store from '@/store/store';

var moment = require('moment');

store.dispatch('session/loadStore');

Vue.config.productionTip = false;
 
Vue.use(VTooltip);
Vue.use(UUID);
Vue.use(AxiosPlugin);
Vue.use(SerializerPlugin);
Vue.use(BootstrapVue);

Vue.use(ApiPlugin, { 
    store: store,
    router: router 
});

Vue.use(VeeValidate, { 
    mode: 'eager',
    fieldsBagName: 'formFields'
});

 
Vue.use(VueMq, {
    breakpoints: { 
        mobile: 450,
        tablet: 900,
        laptop: 1250,
        desktop: Infinity
    }
});

Vue.component('vue-headful', VueHeadful);

Vue.filter('date', date => {
    if(date != null){
        return moment(date).format('D MMMM YYYY');
    }else{
        return '';
    }
});

Vue.filter('time-left', date => {
    if(date != null){
        return moment(date).toNow(true) + ' left';
    }else{
        return '';
    }
});

VeeValidate.Validator.extend('verify_password', {
    getMessage: () => `The password must contain at least: 1 uppercase letter, 1 number, and 1 special character.`,
    validate: value => {
        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*+])(?=.{8,})");
        return strongRegex.test(value);
    }
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
